document.addEventListener("DOMContentLoaded", async () => {
    const { initFixedAnchorLink } = await import("../components/anchorlink.js");
    initFixedAnchorLink();

    const inputEls = document.querySelector('.js-search-input');
    if (inputEls) {
        const { clearInput } = await import("../components/input.js");
        clearInput(inputEls);

        // Prevent form submission on Enter
        inputEls.addEventListener('submit', (e) => {
            e.preventDefault();
        });
    }
    const { markHighLight } = await import("../components/mark.js");
    markHighLight();
});
